const slugs = {
  // private
  dashboard: "/dashboard",
  cms_home: "/management/cms/home",
  cms_banking: "/management/cms/banking",
  cms_faqs: "/management/cms/faqs",
  cms_testimonials: "/management/cms/testimonials",
  cms_ecosystem: "/management/cms/ecosystem",
  cms_blogs: "/management/cms/blogs",
  cms_partners: "/management/cms/partners",
  cms_advantages: "/management/cms/advantages",
  cms_how_it_works: "/management/cms/how-it-works",
  cms_features: "/management/cms/features",
  cms_about: "/management/cms/about",
  cms_cta_sections: "/management/cms/cta-sections",
  cms_settings: "/management/cms/settings",
  cms_admins: "/management/cms/admins",
  
  // auth
  login: "/login",
  forgotPassword: "/forgot_password",
  changePasswordFromEmail: "/reset-password",
  
  // fallback
  page404: "/login",
};

export default slugs;
